import React, { useState, Component } from 'react';
import { SearchIcon, FilterIcon, ChevronRightIcon, ChevronLeftIcon, CheckCircleIcon, ClockIcon, TruckIcon, PackageIcon, ShieldIcon, ArrowRightIcon, CalendarIcon, InfoIcon, MapPinIcon, DownloadIcon, SlidersIcon, XCircleIcon, AlertCircleIcon, ChevronDownIcon, ArrowUpDownIcon, PlusIcon, MoreHorizontalIcon, EyeIcon, FileTextIcon, RefreshCwIcon, BoxIcon, TagIcon, DollarSignIcon, BuildingIcon, UserIcon, ChevronUpIcon, ListFilterIcon, SlidersHorizontalIcon, ArrowDownIcon, ArrowUpIcon, BarChartIcon, PieChartIcon, GridIcon, ListIcon, BellIcon, HelpCircleIcon, BarChart3Icon } from 'lucide-react';
// Component for tab buttons
function TabButton({
  active,
  onClick,
  label
}) {
  return <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${active ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white' : 'text-blue-200 hover:bg-white/5'}`} onClick={onClick} data-id="element-9639">
      {label}
    </button>;
}
// Component for shipping status boxes
function ShippingStatusBox({
  status,
  label,
  date
}) {
  const getIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-9640" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-9641" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-9642" />;
    }
  };
  return <div className="flex flex-col items-center bg-white/5 rounded-lg p-1.5" data-id="element-9643">
      {getIcon(status)}
      <span className="text-xs text-blue-300 mt-1 text-center" data-id="element-9644">{label}</span>
      {date && <span className="text-xs text-blue-200 mt-0.5 text-center" data-id="element-9645">{date}</span>}
    </div>;
}
// Component for order cards in grid view
function OrderCard({
  order
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-9646" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-9647" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-9648" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-9649" />;
      default:
        return <InfoIcon size={14} data-id="element-9650" />;
    }
  };
  return <div className="bg-gradient-to-br from-white/5 to-white/10 rounded-lg overflow-hidden border border-white/10 hover:border-white/20 transition-colors" data-id="element-9651">
      <div className="p-4 border-b border-white/10" data-id="element-9652">
        <div className="flex justify-between items-start mb-3" data-id="element-9653">
          <div className="font-medium text-white" data-id="element-9654">{order.id}</div>
          <div className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize flex items-center ${getStatusBg(order.status)} ${getStatusColor(order.status)}`} data-id="element-9655">
            {getStatusIcon(order.status)}
            <span className="ml-1" data-id="element-9656">{order.status}</span>
          </div>
        </div>
        <div className="text-sm text-blue-300 flex items-center mb-3" data-id="element-9657">
          <CalendarIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9658" />
          {order.date}
        </div>
        <div className="flex justify-between items-end" data-id="element-9659">
          <div data-id="element-9660">
            <div className="text-xs text-blue-300 mb-1" data-id="element-9661">Products</div>
            <div className="text-sm text-white" data-id="element-9662">{order.products}</div>
          </div>
          <div className="text-right" data-id="element-9663">
            <div className="text-xs text-blue-300 mb-1" data-id="element-9664">Amount</div>
            <div className="text-sm font-medium text-white" data-id="element-9665">{order.amount}</div>
          </div>
        </div>
      </div>
      <div className="p-4 bg-blue-950/30" data-id="element-9666">
        <div className="mb-3" data-id="element-9667">
          <div className="text-xs text-blue-300 mb-1" data-id="element-9668">Bill by</div>
          <div className="text-sm text-white" data-id="element-9669">{order.billBy}</div>
        </div>
        <div className="mb-4" data-id="element-9670">
          <div className="text-xs text-blue-300 mb-1" data-id="element-9671">Bill to</div>
          <div className="text-sm text-white truncate" data-id="element-9672">{order.billTo}</div>
        </div>
        <div className="flex justify-between" data-id="element-9673">
          <button className="px-3 py-1.5 text-xs bg-white/10 text-blue-200 rounded hover:bg-white/20 hover:text-white transition-colors" data-id="element-9674">
            <FileTextIcon size={14} className="mr-1" data-id="element-9675" />
            Invoice
          </button>
          <button className="px-3 py-1.5 text-xs bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-9676">
            <EyeIcon size={14} className="mr-1" data-id="element-9677" />
            Details
          </button>
        </div>
      </div>
    </div>;
}
// Empty state component
function EmptyState({
  onClearFilters,
  className = ''
}) {
  return <div className={`p-8 text-center ${className}`} data-id="element-9678">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-900/20 mb-4" data-id="element-9679">
        <SearchIcon size={24} className="text-blue-400" data-id="element-9680" />
      </div>
      <h3 className="text-lg font-medium text-white mb-2" data-id="element-9681">No orders found</h3>
      <p className="text-blue-300 max-w-md mx-auto" data-id="element-9682">
        We couldn't find any orders matching your current filters. Try adjusting
        your search criteria or clear all filters.
      </p>
      <button className="mt-4 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" onClick={onClearFilters} data-id="element-9683">
        Clear All Filters
      </button>
    </div>;
}
export function OrdersPage() {
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // list or grid
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    status: [],
    region: [],
    dateRange: 'all'
  });
  // Mock data for orders
  const orders = [{
    id: 'Q4ZESF',
    status: 'scheduled',
    date: 'Jul 22, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '2 pivots',
    amount: '$ 174,650.94',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      shipping: {
        status: 'pending',
        date: 'Jul 30, 2025'
      }
    }
  }, {
    id: 'UMRX5S',
    status: 'shipped',
    date: 'Jul 9, 2025',
    billBy: 'Walsh Auto Supply',
    billTo: 'Walsh Auto Supply',
    products: '2 pivots',
    amount: '$ 302,903.41',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: '7IIT03',
    status: 'shipped',
    date: 'Jul 8, 2025',
    billBy: 'Aisco EUROPE',
    billTo: 'IMPER REGAS Lda (Olivenza, Badajoz, España)',
    products: '1 pivot',
    amount: '53,520.49 €',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: 'H93M5H',
    status: 'shipped',
    date: 'Jun 27, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '4 pivots',
    amount: '$ 249,467.60',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 7, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 18, 2025'
      }
    }
  }, {
    id: '6URMLZ',
    status: 'pending',
    date: 'Jun 25, 2025',
    billBy: 'CAN AGRO LLP',
    billTo: 'АФ ВЕДЕНОВКА (Очередь 3 v2)',
    products: '7 pivots',
    amount: '$ 477,917.06',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }, {
    id: 'U4OLLY',
    status: 'pending',
    date: 'Jun 18, 2025',
    billBy: 'DAIRY GLOBAL EXPERTS LLC',
    billTo: 'ПСП ВІКТОРІЯ',
    products: '1 pivot',
    amount: '$ 43,228.92',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }];
  // Filter and sort orders
  const filteredOrders = orders.filter(order => {
    // Filter by search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return order.id.toLowerCase().includes(query) || order.billBy.toLowerCase().includes(query) || order.billTo.toLowerCase().includes(query) || order.products.toLowerCase().includes(query);
    }
    // Filter by status
    if (selectedFilters.status.length > 0 && !selectedFilters.status.includes(order.status)) {
      return false;
    }
    // Filter by region
    if (selectedFilters.region.length > 0 && !selectedFilters.region.includes(order.region)) {
      return false;
    }
    // Filter by tab
    if (activeTab === 'active' && order.status === 'canceled') {
      return false;
    } else if (activeTab === 'closed' && order.status !== 'shipped') {
      return false;
    } else if (activeTab === 'canceled' && order.status !== 'canceled') {
      return false;
    }
    return true;
  });
  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortField === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'amount') {
      const amountA = parseFloat(a.amount.replace(/[^0-9.-]+/g, ''));
      const amountB = parseFloat(b.amount.replace(/[^0-9.-]+/g, ''));
      return sortDirection === 'asc' ? amountA - amountB : amountB - amountA;
    } else if (sortField === 'id') {
      return sortDirection === 'asc' ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id);
    }
    return 0;
  });
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-9684" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-9685" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-9686" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-9687" />;
      default:
        return <InfoIcon size={14} data-id="element-9688" />;
    }
  };
  const getShippingStatusIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-9689" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-9690" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-9691" />;
    }
  };
  const handleOrderClick = id => {
    setExpandedOrder(expandedOrder === id ? null : id);
  };
  const toggleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };
  const toggleFilter = (type, value) => {
    setSelectedFilters(prev => {
      const newFilters = {
        ...prev
      };
      if (type === 'dateRange') {
        newFilters.dateRange = value;
      } else {
        if (newFilters[type].includes(value)) {
          newFilters[type] = newFilters[type].filter(item => item !== value);
        } else {
          newFilters[type] = [...newFilters[type], value];
        }
      }
      return newFilters;
    });
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9692">
      {/* Header with navigation */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-9693">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-9694">
          <div className="flex items-center" data-id="element-9695">
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-9696">
              <TruckIcon size={20} className="text-white" data-id="element-9697" />
            </div>
            <div data-id="element-9698">
              <h1 className="text-xl font-bold text-white" data-id="element-9699">Orders</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-9700">
                Manage and track all your orders
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-9701">
            <div className="relative hidden sm:block" data-id="element-9702">
              <div className="relative" data-id="element-9703">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-9704" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-9705" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9706">
              <CalendarIcon size={20} data-id="element-9707" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9708">
              <BarChart3Icon size={20} data-id="element-9709" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9710">
              <HelpCircleIcon size={20} data-id="element-9711" />
            </button>
            <div className="relative" data-id="element-9712">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-9713">
                <BellIcon size={20} data-id="element-9714" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-9715">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-9716">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-9717">
                <UserIcon size={16} className="text-white" data-id="element-9718" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-9719">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-9720" />
            </div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg flex items-center" data-id="element-9721">
              <PlusIcon size={16} className="mr-2" data-id="element-9722" />
              New Order
            </button>
          </div>
        </div>
      </header>
      {/* Main content */}
      <div className="p-4 md:p-6" data-id="element-9723">
        <div className="bg-white/5 backdrop-blur-md rounded-xl border border-white/10 overflow-hidden shadow-xl" data-id="element-9724">
          {/* Tabs and search */}
          <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-white/10 p-4" data-id="element-9725">
            <div className="flex space-x-1 mb-4 md:mb-0" data-id="element-9726">
              <TabButton active={activeTab === 'active'} onClick={() => setActiveTab('active')} label="Active orders" data-id="element-9727" />
              <TabButton active={activeTab === 'closed'} onClick={() => setActiveTab('closed')} label="Closed orders" data-id="element-9728" />
              <TabButton active={activeTab === 'canceled'} onClick={() => setActiveTab('canceled')} label="Canceled orders" data-id="element-9729" />
            </div>
            <div className="flex space-x-2" data-id="element-9730">
              <div className="relative flex-grow" data-id="element-9731">
                <input type="text" placeholder="Search by code, name, dealer, customer..." className="w-full md:w-80 bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-9732" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={16} data-id="element-9733" />
              </div>
              <button className={`p-2 rounded-lg ${filtersOpen ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'} transition-colors`} onClick={() => setFiltersOpen(!filtersOpen)} data-id="element-9734">
                <FilterIcon size={16} data-id="element-9735" />
              </button>
              <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-9736">
                <DownloadIcon size={16} data-id="element-9737" />
              </button>
              <div className="hidden md:flex space-x-2" data-id="element-9738">
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-9739">
                  <ListIcon size={16} data-id="element-9740" />
                </button>
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-9741">
                  <GridIcon size={16} data-id="element-9742" />
                </button>
              </div>
            </div>
          </div>
          {/* Filters panel */}
          {filtersOpen && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 border-b border-white/10 p-4" data-id="element-9743">
              <div className="flex flex-wrap gap-4" data-id="element-9744">
                <div data-id="element-9745">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-9746">
                    Status
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-9747">
                    {['pending', 'scheduled', 'shipped', 'canceled'].map(status => <button key={status} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.status.includes(status) ? `${getStatusBg(status)} ${getStatusColor(status)}` : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('status', status)} data-id="element-9748">
                          <span data-id="element-9749">{getStatusIcon(status)}</span>
                          <span data-id="element-9750">{status}</span>
                          {selectedFilters.status.includes(status) && <XCircleIcon size={12} data-id="element-9751" />}
                        </button>)}
                  </div>
                </div>
                <div data-id="element-9752">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-9753">
                    Region
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-9754">
                    {['America', 'Europe', 'Asia', 'ANZ'].map(region => <button key={region} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.region.includes(region) ? 'bg-indigo-500/20 text-indigo-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('region', region)} data-id="element-9755">
                        <MapPinIcon size={12} data-id="element-9756" />
                        <span data-id="element-9757">{region}</span>
                        {selectedFilters.region.includes(region) && <XCircleIcon size={12} data-id="element-9758" />}
                      </button>)}
                  </div>
                </div>
                <div data-id="element-9759">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-9760">
                    Date Range
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-9761">
                    {[{
                  id: 'all',
                  label: 'All Time'
                }, {
                  id: 'today',
                  label: 'Today'
                }, {
                  id: 'week',
                  label: 'This Week'
                }, {
                  id: 'month',
                  label: 'This Month'
                }, {
                  id: 'quarter',
                  label: 'This Quarter'
                }].map(range => <button key={range.id} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.dateRange === range.id ? 'bg-blue-500/20 text-blue-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('dateRange', range.id)} data-id="element-9762">
                        <CalendarIcon size={12} data-id="element-9763" />
                        <span data-id="element-9764">{range.label}</span>
                      </button>)}
                  </div>
                </div>
              </div>
              <div className="flex justify-between mt-4 pt-4 border-t border-white/5" data-id="element-9765">
                <button className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white/5 text-blue-200 hover:bg-white/10 transition-colors" onClick={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-9766">
                  Clear All Filters
                </button>
                <div className="text-sm text-blue-300" data-id="element-9767">
                  Showing{' '}
                  <span className="font-medium text-white" data-id="element-9768">
                    {sortedOrders.length}
                  </span>{' '}
                  of{' '}
                  <span className="font-medium text-white" data-id="element-9769">
                    {orders.length}
                  </span>{' '}
                  orders
                </div>
              </div>
            </div>}
          {viewMode === 'list' ? <>
              {/* Table header */}
              <div className="hidden md:grid grid-cols-12 gap-2 p-4 text-xs font-medium text-blue-300 border-b border-white/10" data-id="element-9770">
                <div className="col-span-1" data-id="element-9771">Status</div>
                <div className="col-span-2 flex items-center cursor-pointer group" onClick={() => toggleSort('id')} data-id="element-9772">
                  Code / Date
                  <button className="ml-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-9773">
                    {sortField === 'id' ? sortDirection === 'asc' ? <ArrowUpIcon size={12} data-id="element-9774" /> : <ArrowDownIcon size={12} data-id="element-9775" /> : <ArrowUpDownIcon size={12} data-id="element-9776" />}
                  </button>
                </div>
                <div className="col-span-3" data-id="element-9777">Bill by / Bill to</div>
                <div className="col-span-2" data-id="element-9778">Products</div>
                <div className="col-span-3" data-id="element-9779">Shipping schedule</div>
                <div className="col-span-1 text-right" data-id="element-9780">Actions</div>
              </div>
              {/* Table content */}
              <div className="divide-y divide-white/10" data-id="element-9781">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <div key={order.id} className="group" data-id="element-9782">
                      <div className="grid grid-cols-1 md:grid-cols-12 gap-2 p-4 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => handleOrderClick(order.id)} data-id="element-9783">
                        {/* Status - Mobile & Desktop */}
                        <div className="col-span-1 flex md:block items-center justify-between" data-id="element-9784">
                          <div className={`flex items-center space-x-1.5 ${getStatusColor(order.status)}`} data-id="element-9785">
                            <span className={`p-1 rounded-md ${getStatusBg(order.status)}`} data-id="element-9786">
                              {getStatusIcon(order.status)}
                            </span>
                            <span className="capitalize font-medium" data-id="element-9787">
                              {order.status}
                            </span>
                          </div>
                          <button className="md:hidden p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-9788">
                            <ChevronRightIcon size={16} className={`transition-transform ${expandedOrder === order.id ? 'rotate-90' : ''}`} data-id="element-9789" />
                          </button>
                        </div>
                        {/* Code & Date - Desktop */}
                        <div className="col-span-2 hidden md:block" data-id="element-9790">
                          <div className="font-medium text-white" data-id="element-9791">
                            {order.id}
                          </div>
                          <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-9792">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-9793" />
                            {order.date}
                          </div>
                        </div>
                        {/* Code & Date - Mobile */}
                        <div className="md:hidden flex justify-between items-center" data-id="element-9794">
                          <div data-id="element-9795">
                            <div className="font-medium text-white" data-id="element-9796">
                              {order.id}
                            </div>
                            <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-9797">
                              <CalendarIcon size={14} className="mr-1.5" data-id="element-9798" />
                              {order.date}
                            </div>
                          </div>
                        </div>
                        {/* Bill by / Bill to - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-9799">
                          <div className="font-medium text-white flex items-center" data-id="element-9800">
                            <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9801" />
                            {order.billBy}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-9802">
                            <UserIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9803" />
                            <span className="truncate" data-id="element-9804">{order.billTo}</span>
                          </div>
                        </div>
                        {/* Products - Desktop */}
                        <div className="col-span-2 hidden md:flex flex-col" data-id="element-9805">
                          <div className="font-medium text-white flex items-center" data-id="element-9806">
                            <BoxIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9807" />
                            {order.products}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-9808">
                            <TagIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9809" />
                            {order.amount}
                          </div>
                        </div>
                        {/* Shipping schedule - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-9810">
                          <div className="grid grid-cols-4 gap-1" data-id="element-9811">
                            <ShippingStatusBox status={order.shipping.approved.status} label="Approved" date={order.shipping.approved.date} data-id="element-9812" />
                            <ShippingStatusBox status={order.shipping.acknowledgment.status} label="Ack." date={order.shipping.acknowledgment.date} data-id="element-9813" />
                            <ShippingStatusBox status={order.shipping.readyToLoad.status} label="Ready" date={order.shipping.readyToLoad.date} data-id="element-9814" />
                            <ShippingStatusBox status={order.shipping.shipping.status} label="Ship" date={order.shipping.shipping.date} data-id="element-9815" />
                          </div>
                        </div>
                        {/* Actions - Desktop */}
                        <div className="col-span-1 flex justify-end items-start space-x-1 hidden md:flex" data-id="element-9816">
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-9817">
                            <EyeIcon size={16} data-id="element-9818" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-9819">
                            <FileTextIcon size={16} data-id="element-9820" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-9821">
                            <MoreHorizontalIcon size={16} data-id="element-9822" />
                          </button>
                        </div>
                      </div>
                      {/* Expanded view */}
                      {expandedOrder === order.id && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 p-4 border-t border-white/10" data-id="element-9823">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-9824">
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-9825">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-9826">
                                <InfoIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9827" />
                                Order Details
                              </h3>
                              <div className="space-y-3" data-id="element-9828">
                                <div className="flex justify-between" data-id="element-9829">
                                  <span className="text-sm text-blue-300" data-id="element-9830">
                                    Order ID:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-9831">
                                    {order.id}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9832">
                                  <span className="text-sm text-blue-300" data-id="element-9833">
                                    Order Date:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-9834">
                                    {order.date}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9835">
                                  <span className="text-sm text-blue-300" data-id="element-9836">
                                    Status:
                                  </span>
                                  <span className={`text-sm font-medium capitalize ${getStatusColor(order.status)}`} data-id="element-9837">
                                    {order.status}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9838">
                                  <span className="text-sm text-blue-300" data-id="element-9839">
                                    Amount:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-9840">
                                    {order.amount}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9841">
                                  <span className="text-sm text-blue-300" data-id="element-9842">
                                    Region:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-9843">
                                    {order.region}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-9844">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-9845">
                                <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9846" />
                                Billing Information
                              </h3>
                              <div className="space-y-3" data-id="element-9847">
                                <div className="flex justify-between" data-id="element-9848">
                                  <span className="text-sm text-blue-300" data-id="element-9849">
                                    Bill by:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-9850">
                                    {order.billBy}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9851">
                                  <span className="text-sm text-blue-300" data-id="element-9852">
                                    Bill to:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-9853">
                                    {order.billTo}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-9854">
                                  <span className="text-sm text-blue-300" data-id="element-9855">
                                    Products:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-9856">
                                    {order.products}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-9857">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-9858">
                                <TruckIcon size={14} className="mr-1.5 text-blue-400" data-id="element-9859" />
                                Shipping Timeline
                              </h3>
                              <div className="space-y-3" data-id="element-9860">
                                <div className="flex items-center" data-id="element-9861">
                                  {getShippingStatusIcon(order.shipping.approved.status)}
                                  <div className="ml-2" data-id="element-9862">
                                    <div className="text-sm text-white" data-id="element-9863">
                                      Approved
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-9864">
                                      {order.shipping.approved.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-9865">
                                  {getShippingStatusIcon(order.shipping.acknowledgment.status)}
                                  <div className="ml-2" data-id="element-9866">
                                    <div className="text-sm text-white" data-id="element-9867">
                                      Acknowledgment
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-9868">
                                      {order.shipping.acknowledgment.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-9869">
                                  {getShippingStatusIcon(order.shipping.readyToLoad.status)}
                                  <div className="ml-2" data-id="element-9870">
                                    <div className="text-sm text-white" data-id="element-9871">
                                      Ready to load
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-9872">
                                      {order.shipping.readyToLoad.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-9873">
                                  {getShippingStatusIcon(order.shipping.shipping.status)}
                                  <div className="ml-2" data-id="element-9874">
                                    <div className="text-sm text-white" data-id="element-9875">
                                      Shipping
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-9876">
                                      {order.shipping.shipping.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end mt-4 space-x-2" data-id="element-9877">
                            <button className="px-3 py-1.5 text-sm bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors" data-id="element-9878">
                              Download Invoice
                            </button>
                            <button className="px-3 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-9879">
                              View Details
                            </button>
                          </div>
                        </div>}
                    </div>) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-9880" />}
              </div>
            </> :
        // Grid view
        <div className="p-4" data-id="element-9881">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-9882">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <OrderCard key={order.id} order={order} data-id="element-9883" />) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} className="col-span-full" data-id="element-9884" />}
              </div>
            </div>}
          {/* Pagination */}
          {sortedOrders.length > 0 && <div className="flex items-center justify-between p-4 border-t border-white/10" data-id="element-9885">
              <div className="text-sm text-blue-300" data-id="element-9886">
                Showing{' '}
                <span className="font-medium text-white" data-id="element-9887">
                  {sortedOrders.length}
                </span>{' '}
                of{' '}
                <span className="font-medium text-white" data-id="element-9888">{orders.length}</span>{' '}
                orders
              </div>
              <div className="flex items-center space-x-1" data-id="element-9889">
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-9890">
                  <ChevronLeftIcon size={16} data-id="element-9891" />
                </button>
                <button className="w-8 h-8 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white flex items-center justify-center" data-id="element-9892">
                  1
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-9893">
                  2
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-9894">
                  3
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-9895">
                  4
                </button>
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-9896">
                  <ChevronRightIcon size={16} data-id="element-9897" />
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}